import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ApiClient } from 'spry-react/utils/apiClient';

export function accountSettingsRoutes(loaderApiClient: ApiClient): RouteObject {
  return {
    path: "account",
    lazy: async () => {
      const { loader, AccountSettingsPage  } = await import('./accountSettingsPage');
      return {
        element: <AccountSettingsPage />,
        loader: () => loader(loaderApiClient),
      };
    },
  };
}

export class AccountSettingsUrls
{
  public static settings() {
    return "/account";
  }
}

